const makeJSDateObject = date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

export default makeJSDateObject;
